import { useState } from 'react';
import { Search, X } from 'lucide-react';
import { FormField, FormLabel, FormInput, FormSelect, FormCheckbox, Button } from '../ui';
import { MessageQueueFilters as FiltersType } from '../../types/messageQueue';

interface MessageQueueFiltersProps {
  filters: FiltersType;
  onFilterChange: (filters: FiltersType) => void;
  onResetFilters: () => void;
  integrations: any[];
}

function MessageQueueFilters({
  filters,
  onFilterChange,
  onResetFilters,
  integrations,
}: MessageQueueFiltersProps) {
  const [localFilters, setLocalFilters] = useState<FiltersType>({
    ...filters,
  });

  const handleLocalFilterChange = (name: string, value: any) => {
    setLocalFilters(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleApplyFilters = () => {
    onFilterChange({
      ...localFilters,
      page: 1, // Reset to first page when filters change
    });
  };

  const isFiltered = Object.keys(filters).some(
    key => key !== 'page' && key !== 'limit' && filters[key as keyof FiltersType]
  );

  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <FormField>
          <FormLabel htmlFor="name">Nome</FormLabel>
          <FormInput
            id="name"
            name="name"
            value={localFilters.name || ''}
            onChange={e => handleLocalFilterChange('name', e.target.value)}
            placeholder="Buscar por nome..."
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="integration_id">Integração</FormLabel>
          <FormSelect
            id="integration_id"
            name="integration_id"
            value={localFilters.integration_id?.toString() || ''}
            onChange={e =>
              handleLocalFilterChange(
                'integration_id',
                e.target.value ? Number(e.target.value) : undefined
              )
            }
          >
            <option value="">Todas</option>
            {integrations.map(integration => (
              <option key={integration.id} value={integration.id}>
                {integration.description}
              </option>
            ))}
          </FormSelect>
        </FormField>

        <div className="flex flex-col justify-end space-y-2">
          <FormField>
            <div className="flex items-center">
              <FormCheckbox
                id="default"
                name="default"
                checked={!!localFilters.default}
                onChange={e => handleLocalFilterChange('default', e.target.checked)}
              />
              <FormLabel htmlFor="default" className="ml-2 mb-0">
                Fila Padrão
              </FormLabel>
            </div>
          </FormField>

          <FormField>
            <div className="flex items-center">
              <FormCheckbox
                id="screening"
                name="screening"
                checked={!!localFilters.screening}
                onChange={e => handleLocalFilterChange('screening', e.target.checked)}
              />
              <FormLabel htmlFor="screening" className="ml-2 mb-0">
                Requer Triagem
              </FormLabel>
            </div>
          </FormField>

          <FormField>
            <div className="flex items-center">
              <FormCheckbox
                id="ia_respond"
                name="ia_respond"
                checked={!!localFilters.ia_respond}
                onChange={e => handleLocalFilterChange('ia_respond', e.target.checked)}
              />
              <FormLabel htmlFor="ia_respond" className="ml-2 mb-0">
                IA Responde Automaticamente
              </FormLabel>
            </div>
          </FormField>
        </div>
      </div>

      <div className="flex justify-end mt-4 space-x-2">
        {isFiltered && (
          <Button variant="secondary" onClick={onResetFilters} className="flex items-center">
            <X className="h-4 w-4 mr-2" />
            Limpar Filtros
          </Button>
        )}
        <Button onClick={handleApplyFilters} className="flex items-center">
          <Search className="h-4 w-4 mr-2" />
          Filtrar
        </Button>
      </div>
    </div>
  );
}

export default MessageQueueFilters;
